const defaultBanner = '/images/parallax/FLXR-media.jpg';

type Props = {
    overline?: string;
    title?: string;
    style?: 'white';
    height?: string;
    backgroundSize?: string;
    backgroundPosition?: string;
    className?: string;
    children?: React.ReactNode;
    parallaxSpeed?: number;
    src?: string;
};
const HeroContent = ({
                         src = defaultBanner,
                         height = "450px",
                         backgroundSize,
                         backgroundPosition,
                         className,
                         children
                     }: Props) => {



    // uses bg-fixed
    return (
        <div className="relative flex items-center justify-center" style={{height}}>
            <div className="absolute top-0 left-0 w-full h-full z-0 overflow-hidden">
                <div
                    className={`w-[calc(100%+40px)] h-full bg-cover bg-center bg-scroll md:bg-fixed move-background ${className}`}
                    style={{
                        backgroundImage: `url('${src}')`,
                        backgroundSize,
                        backgroundPosition,
                    }}
                />
            </div>
            <div className='z-1'>
                {children}
            </div>
        </div>
    )


};

export default HeroContent;
